<template>
  <div class="training-datasets">
    <h3>
      Training Datasets
      <a href="#" @click.prevent="trainNewDataset">Retrain bot</a>
    </h3>

    <ul>
      <li v-if="trainingDatasets.length === 0">No training datasets yet</li>
      <li v-for="dataset in trainingDatasets" :key="dataset.id">
        <timeago :since="dataset.created_at" :auto-update="10"></timeago> ({{ dataset.status }})
      </li>
    </ul>
  </div>
</template>

<script>
import _ from "underscore";

import api from "@/helpers/api";
import auth from "@/helpers/auth";

const apiVersion = 'v1';
const source = 'training_datasets';

export default {
  data() {
    return {
      trainingDatasets: [],
      pollTimeout: null
    };
  },

  created() {
    this.getTrainingDatasets();
  },

  methods: {
    getTrainingDatasets() {
      api
        .instance()
        .get(`${apiVersion}/${source}`, { params: { team_id: auth.teamId() } })
        .then((resp) => {
          this.trainingDatasets = _.first(
            _.map(resp.data.data, (data) => {
              return data.attributes;
            }),
            3
          );

          this.pollForProcessedDatasets();
        })
        .catch((err) => {
          console.error("Error getting training datasets", err);
        });
    },

    trainNewDataset() {
      api
        .instance()
        .post(`${apiVersion}/${source}`, { team_id: auth.teamId() })
        .then((resp) => {
          this.trainingDatasets.unshift(resp.data.data.attributes);
          this.trainingDatasets = _.first(this.trainingDatasets, 3);
          this.pollForProcessedDatasets();
        })
        .catch((err) => {
          console.error("Error creating new training dataset", err);
        });
    },

    pollForProcessedDatasets() {
      clearTimeout(this.pollTimeout);

      this.pollTimeout = setTimeout(() => {
        const notReady = _.select(this.trainingDatasets, (td) => {
          return !_.contains(["ready", "failed"], td.status);
        });

        if (notReady.length) this.getTrainingDatasets();
      }, 1000);
    }
  }
};
</script>
